<header-bar [pageTitle]="title" headingClass="fa-user-o"></header-bar>
<form [formGroup]="keyContactForm" (ngSubmit)="save(keyContactForm.value, keyContactForm.valid)" novalidate>
    <div class="container mt-5 pb-5 mb-5">
        <div class="row mb-5">
            <div class="col">
                <div class="card mb-5">
                    <div class="card-header text-white bg-primary">
                        <div class="row align-items-center">
                            <p class="h3 m-0 col">Key contact</p>
                            <div class="col text-right">
                                <button type="submit" class="btn btn-outline-light btn-sm u-marginBottom--medium" [disabled]="!keyContactForm.valid">
                                    Save changes
                                    <i class="fa fa-check ml-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group" [ngClass]="{ 'has-error': !keyContactForm.controls['name'].valid && keyContactForm.controls['name'].touched }">
                                    <label for="name" class="textBody--sm">Name</label>
                                    <input type="text" id="name" formControlName="name" class="form-control" />
                                    <div *ngIf="keyContactForm.controls['name'].hasError('required') && keyContactForm.controls['name'].touched" class="alert alert-danger">You must include a name.</div>
                                </div>
                                <div class="form-group" [ngClass]="{ 'has-error': !keyContactForm.controls['email'].valid && keyContactForm.controls['email'].touched }">
                                    <label for="email" class="textBody--sm">Email</label>
                                    <input type="text" id="email" formControlName="email" class="form-control" />
                                    <div *ngIf="keyContactForm.controls['email'].hasError('required') && keyContactForm.controls['email'].touched" class="alert alert-danger">You must include an email address.</div>
                                    <div *ngIf="keyContactForm.controls['email'].hasError('pattern') && keyContactForm.controls['email'].touched" class="alert alert-danger">Email is invalid.</div>
                                </div>
                                <div class="form-group" [ngClass]="{ 'has-error': !keyContactForm.controls['location'].valid && keyContactForm.controls['location'].touched }">
                                    <label for="location" class="textBody--sm">Location</label>
                                    <input type="text" id="location" formControlName="location" class="form-control" />
                                    <div *ngIf="keyContactForm.controls['location'].hasError('required') && keyContactForm.controls['location'].touched" class="alert alert-danger">You must include a location.</div>
                                </div>
                                <div class="form-group">
                                    <label for="deleted">Disable Item</label>
                                    <p class="textBody--xs">
                                        <input type="checkbox" id="deleted" name="disabled" formControlName="disabled" class="u-marginTop--small " />
                                        If checked this contact will no longer be displayed
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>